import { render, staticRenderFns } from "./ProductSubscriptionPlan.vue?vue&type=template&id=f31959c2"
import script from "./ProductSubscriptionPlan.vue?vue&type=script&lang=js"
export * from "./ProductSubscriptionPlan.vue?vue&type=script&lang=js"
import style0 from "./ProductSubscriptionPlan.vue?vue&type=style&index=0&id=f31959c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports